import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleableInput", "toggleableBlock"]

  connect() {
    // Initial visibility check of all inputs when controller connects
    this.toggleAllBlocks();
    this.toggleAllInputs();
  }

  toggleAllInputs(){
    this.toggleableInputTargets.forEach(element => {
      if(element.dataset.formVisibilityInputObjective && element.dataset.formVisibilityToggleInputWhen){
        this.toggleInput(element);
      }
    })
  }

  toggleAllBlocks(){
    this.toggleableInputTargets.forEach(element => {
      if(element.dataset.formVisibilityBlockObjective && element.dataset.formVisibilityToggleBlockWhen){
        this.toggleBlock(element);
      }
    })
  }

  toggleInput(element){
    element = element.target? element.target : element;
    const objectives = element.dataset.formVisibilityInputObjective?.split(';') || [];
    const conditions = element.dataset.formVisibilityToggleInputWhen?.split(';') || [];
    if(objectives != undefined && objectives != '' && conditions != undefined && conditions != ''){
      const shouldShow = this.shouldShow(conditions)

      objectives.forEach(objective => {
        const objectiveWrapper = this.toggleableInputTargets.find(input => input.id === objective).closest('.form_group');
        shouldShow ? objectiveWrapper.classList.remove('hide') : objectiveWrapper.classList.add('hide');
      })
    }
  }

  toggleBlock(element){
    element = element.target? element.target : element;
    const objectives = element.dataset.formVisibilityBlockObjective?.split(';') || [];
    const conditions = element.dataset.formVisibilityToggleBlockWhen?.split(';') || [];
    if(objectives != undefined && objectives != '' && conditions != undefined && conditions != ''){
      const shouldShow = this.shouldShow(conditions)

      objectives.forEach(objective => {
        const objectiveBlock = this.toggleableBlockTargets.find(block => block.id === objective)
        shouldShow ? objectiveBlock.classList.remove('hide') : objectiveBlock.classList.add('hide');
      })
    }
  }
  
  shouldShow(conditions){
    return conditions.every(condition => {
      const [conditionInputId, conditionInputValue] = [condition.split(':')[0], this.cleanValue(condition.split(':')[1])]
      const sourceInput = this.toggleableInputTargets.find(input => input.id === conditionInputId)
      const sourceInputValue = this.getCleanSourceValue(sourceInput);

      return sourceInput && sourceInputValue === conditionInputValue
    })
  }

  getCleanSourceValue(input){
    switch(input.type) {
      case 'checkbox':
        return input.checked;    
      case 'radio':
        return input.checked ? input.value : null;
      default:
        return input.value || null;
    }
  }

  cleanValue(value){
    const normalizedValue = value.toLowerCase()
    
    switch (normalizedValue) {
        case 'true':
            return true
        case 'false':
            return false
        default:
            return normalizedValue
    }
  }
}